import React, { Component } from 'react'
import FaExclamationTriangle from 'react-icons/lib/fa/exclamation-triangle'
import LoadingImage from '../../assets/logo-white-transparent.gif'
import { getBestSourceUrl } from '../utilities'
import './player.css'

export default class Player extends Component {
  constructor() {
    super()

    this.state = {
      activity: false,
    }

    this.initPlayer = this.initPlayer.bind(this)
  }

  userActivity() {
    this.setState({ activity: true })
    if (this.activityTimeout) {
      clearTimeout(this.activityTimeout)
    }
    this.activityTimeout = setTimeout(
      () => {
        this.setState({ activity: false })
      },
      1000,
    )
  }

  getSourceUrl(props = this.props) {
    return getBestSourceUrl(props.video)
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.refVideo && this.getSourceUrl(prevProps) !== this.getSourceUrl()) {
      this.refVideo.load()
      this.refVideo.play()
    }
  }

  componentDidMount() {
    this.userActivity()

    this.initPlayer()

    if (this.props.onSizeChange) {
      this.props.onSizeChange(this.calcSize().width)
    }
  }

  componentWillUnmount() {
    if (this.activityTimeout) {
      clearTimeout(this.activityTimeout)
    }
    if (this.waitingTimeout) {
      clearTimeout(this.waitingTimeout)
    }
  }

  togglePlay() {
    if (this.refVideo.paused) {
      this.refVideo.play()
    } else {
      this.refVideo.pause()
    }
  }

  initPlayer() {
    if (!window.VideoPlayer || !this.props.video || !this.refVideo) {
      console.log("waiting ...")
      this.waitingTimeout = setTimeout(this.initPlayer, 500)
      return
    }

    const playerObject = new window.VideoPlayer(this.props.video, this.refVideo)
    playerObject.initialize()
  }
  
  /*shouldComponentUpdate(nextProps, nextState) {
    return false
  }*/

  calcSize() {
    let padding = 215;
    if (this.props.video.height > this.props.video.width) {
      padding = 120;
    }

    let height
    if (this.props.video.height > window.innerHeight - padding) {
      height = window.innerHeight - padding;
      const MIN_HEIGHT = 200;
      const minHeight = this.props.video.height < MIN_HEIGHT ? this.props.video.height : MIN_HEIGHT;
      if (height < minHeight) {
        height = minHeight;
      }
    } else {
      height = this.props.video.height;
    }
    let width = this.props.video.width / this.props.video.height * height;
    if (width > 800 && window.innerWidth < 1200) {
      width = 800;
    }

    return { width, height }
  }

  render() {
    const source = this.getSourceUrl()
    if (
      !source ||
      this.props.video.status < 2 ||
      (this.props.video.new_version && this.props.video.new_version > this.props.video.version)
    ) {
      return (
        <div
          className="player"
          style={
            this.props.video.thumbnail_url
              ? {}
              : {
                height: '300px',
                width: '480px',
                backgroundColor: 'black',
              }
          }
          onClick={(e) => {
            if (this.props.onClick) {
              this.props.onClick(e)
            }
          }}
        >
          {this.props.video.thumbnail_url
            ? <img
              role="presentation"
              className="progress-image"
              src={this.props.video.thumbnail_url}
            />
            : ''}
          <div id="progress-overlay">
            <div className="progress-spinner">
              <img src={LoadingImage} role="presentation" />
            </div>
            <div id="progress-bar-track">
              <div id="progress-bar-value" style={{ width: `${this.props.video.percent || 0}%` }} />
            </div>
            <div className="error-indicator">
              <FaExclamationTriangle />
              <div className="error-message">{this.props.video.error}</div>
            </div>
          </div>
        </div>
      )
    }

    const { height, width } = this.calcSize()

    const extraVideoAttrs = {}
    if (this.props.muted) {
      extraVideoAttrs.muted = true
    }
    if (!this.props.noautoplay) {
      extraVideoAttrs.autoPlay = true
    }
    if (this.props.mobile) {
      extraVideoAttrs.controls = true
    }

    return (
      <div
        className={`player ${this.state.activity ? 'activity' : ''}`}
        onMouseOver={() => this.userActivity()}
        onMouseDown={() => this.userActivity()}
        onClick={(e) => {
          if (this.props.onClick) {
            this.props.onClick(e)
          }
        }}
        style={{
          maxHeight: `${height}px`,
          maxWidth: `${width}px`,
        }}
      >
        <video
          className="video-player-tag"
          playsInline
          poster={this.props.video._poster_url || this.props.video.poster_url}
          loop
          ref={(c) => {
            this.refVideo = c
          }}
          {...extraVideoAttrs}
        >
          <source className="mp4-source" src={source} />
        </video>
        {this.props.me && this.props.me.watermark_url ?
          <a
            className='watermark'
            href={this.props.me.watermark_link}
            target="_blank"
            style={{pointerEvents: this.props.me.watermark_link ? 'auto': 'none'}}
          >
            <img src={this.props.me.watermark_url} />
          </a>
        : ''}
        <div id="spinner" className="player-spinner"></div>
        {this.props.mobile ? '' :
          <div className='player-controls' id="player-controls-footer">
            <div className='player-controls-left'>
              <div id='player-volume' className='player-volume'>
                <div id='player-volume-track' className='player-volume-track'>
                </div>
                <div id='player-volume-value' className='player-volume-value'>
                </div>
                <div role='button' id='player-mute-button' className='player-mute-button'>
                  <svg className="volume-mute" width="32" height="30" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1280 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45z" fill="#fff"/></svg>
                  <svg className="volume-down" width="32" height="30" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1088 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45zm384 544q0 76-42.5 141.5t-112.5 93.5q-10 5-25 5-26 0-45-18.5t-19-45.5q0-21 12-35.5t29-25 34-23 29-35.5 12-57-12-57-29-35.5-34-23-29-25-12-35.5q0-27 19-45.5t45-18.5q15 0 25 5 70 27 112.5 93t42.5 142z" fill="#fff"/></svg>
                  <svg className="volume-up" width="32" height="30" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M832 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45zm384 544q0 76-42.5 141.5t-112.5 93.5q-10 5-25 5-26 0-45-18.5t-19-45.5q0-21 12-35.5t29-25 34-23 29-35.5 12-57-12-57-29-35.5-34-23-29-25-12-35.5q0-27 19-45.5t45-18.5q15 0 25 5 70 27 112.5 93t42.5 142zm256 0q0 153-85 282.5t-225 188.5q-13 5-25 5-27 0-46-19t-19-45q0-39 39-59 56-29 76-44 74-54 115.5-135.5t41.5-173.5-41.5-173.5-115.5-135.5q-20-15-76-44-39-20-39-59 0-26 19-45t45-19q13 0 26 5 140 59 225 188.5t85 282.5z" fill="#fff"/></svg>
                </div>
              </div>
            </div>
            <div id="player-progress" className="player-progress">
              <div id="player-progress-track" className="player-progress-track"></div>
              <div id="player-progress-value" className="player-progress-value"></div>
            </div>
            <div className='player-controls-right'>
              <div role='button' id='player-fullscreen-button' className='player-fullscreen-button'>
                <svg className="compact" width="23" height="23" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M896 960v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45zm755-672q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23z" fill="#fff"/></svg>
                <svg className="expand" width="23" height="23" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M883 1056q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23zm781-864v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45z" fill="#fff"/></svg>
              </div>
            </div>
          </div>
          }
        
        <div id="context-menu">
          <div className="context-menu-item" id="speed">
            Speed
            <span className="speed-button" data-speed="2">2</span>
            <span className="speed-button" data-speed="1.5">1.5</span>
            <span className="speed-button active"data-speed="1">1</span>
            <span className="speed-button" data-speed=".5">½</span>
            <span className="speed-button" data-speed=".25">¼</span>
          </div>

          <a href={source} className="context-menu-item" id="download" download>Download video</a>

          <a href="#" className="context-menu-item" id="copyurl">Copy video URL</a>
          <a href="#" className="context-menu-item" id="copyembed">Copy embed code</a>
          <a href={`/report/${this.props.video.shortcode}`} target="_blank" className="context-menu-item">Report issue</a>
          <a href="https://streamable.com" target="_blank" className="context-menu-item context-menu-footer"><img src="/favicon.ico" height="16" width="16" /><b>Powered by Streamable</b></a>
        </div>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/misc/player/Player.js